import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

const HeroSection = () => {
  const navigate = useNavigate()
  
  const goToApp = () => {
    navigate('/app')
  }

  return (
    <section className="bg-slate-50 pt-24 pb-16">
      <div className="container-max section-padding">
        <div className="text-center max-w-4xl mx-auto">
          <motion.h1 
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Retrouvez le plaisir de pratiquer l'EMDR.{' '}
            <span className="text-gradient">
              L'efficacité pour vos patients, le confort pour vous.
            </span>
          </motion.h1>
          
          <motion.p 
            className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            EMDR Plus est la solution de stimulation bilatérale complète qui protège vos articulations, 
            s'adapte à chaque patient et utilise une technologie accessible à tous.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <button 
              onClick={goToApp}
              className="btn-primary text-lg px-8 py-4 mb-4"
            >
              Lancer une séance
            </button>
            <p className="text-sm text-gray-500">
              Accès gratuit • Aucune inscription requise
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection 